export { SchoolAssessmentDetail } from "./SchoolAssessmentDetail"
export type { SchoolAssessmentDetailProps } from "./SchoolAssessmentDetail"
